// extracted by mini-css-extract-plugin
export default {"w-100":"C5YRhhXVpt8d81FKTsTYRw==","page_center":"laifd9NisT1eSxfvSmcELw==","form-error":"qCYdKPQL09Oer-AMEjyHgw==","inputWrapper":"_92Ahj15rWwCx46pWQKnxvw=="};